import React from 'react'
import moment from 'moment'

import BodyText from 'components/Luxkit/Typography/BodyText'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import BedbankCancellationPolicy from './BedbankCancellationPolicy'
import BedbankPromotionCancellationPolicy from 'components/OfferPage/Bedbank/BedbankPromotionCancellationPolicy'
import { intlFormatter } from 'lib/datetime/dateUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  checkInDate?: string
  checkOutDate?: string
  offer: App.BedbankOffer
  onlySalePeriod?: boolean
  promotion: App.BedbankPromotion
  rate?: App.BedbankRate | App.OrderBedbankRate
  showNonCancellation?: boolean
}

function BedbankPromotionDetails(props: Props) {
  const {
    checkInDate,
    checkOutDate,
    offer,
    onlySalePeriod,
    promotion,
    rate,
    showNonCancellation,
  } = props

  const validCheckInCheckoutDates = !!(checkInDate && checkOutDate)

  return <VerticalSpacer gap={8}>
    {rate && <BedbankCancellationPolicy
      rate={rate}
      offer={offer}
      showNonCancellation={!!showNonCancellation}
    />}
    {!validCheckInCheckoutDates && promotion.cancellationPolicy && <BedbankPromotionCancellationPolicy
      policyCode={promotion.cancellationPolicy}
    />}
    {!onlySalePeriod && <div>
      <BodyText variant="medium" weight="normal" colour="neutral-two">
        Travel between {intlFormatter(moment(promotion.travelPeriod.from).toDate(), INTL_DMY_CASUAL_FORMAT)} - {intlFormatter(moment(promotion.travelPeriod.to).toDate(), INTL_DMY_CASUAL_FORMAT)}
      </BodyText>
      <BodyText variant="medium" weight="normal" colour="neutral-two">
        Min stay: {pluralizeToString('night', promotion.los)}
      </BodyText>
    </div>}
  </VerticalSpacer>
}

export default BedbankPromotionDetails
